/* eslint-disable no-undef */
import React from "react";

const LANGUAGES = {
    "TEXT_TITLE": ["TKT1", "TKT1"],
    "TEXT_GREETING": [`Hello [@]. Today is [@]`, `Xin chào [@]. Hôm nay là [@]`],
    "TEXT_BOT_ID": [`Bot ID`, `Bot ID`],
    "TEXT_JOB_ID": [`Job ID`, `Công việc`],
    "TEXT_ALL": [`All`, `Tất cả`],
    "TEXT_TASK": [`Task`, `Tác vụ`],
    "TEXT_FROM": [`From`, `Từ ngày`],
    "TEXT_SEARCH": [`Search`, `Tìm kiếm`],
    "TEXT_DAILY_VIEW": [`Daily View`, `Lượt xem hàng ngày`],
    "TEXT_PRICE_MIN": [`Price Min`, `Giá tối thiểu`],
    "TEXT_PRICE_MAX": [`Price Max`, `Giá tối đa`],
    "TEXT_SOLD_30_CALCULATE": [`Sold-30 Calculate`, `Ước tính bán 30 ngày`],
    "TEXT_REVENUE_30_CALCULATE": [`Revenue-30 Calculate`, `Ước tính doanh thu 30 ngày`],
    "TEXT_SOLD_30_COUNT": [`Sold-30 Count`, `Thực tế bán 30 ngày`],
    "TEXT_REVENUE_30_COUNT": [`Revenue-30 Count`, `Thực tế doanh thu 30 ngày`],
    "TEXT_FAVORITE": [`Favorite`, `Yêu thích`],
    "TEXT_FAVORITE_RATE": [`Favorite rate`, `Tỉ lệ yêu thích`],
    "TEXT_LAST_UPDATE": [`Last Update`, `Cập nhật`],
    "TEXT_SORT_BY": [`Sort by`, `Sắp xếp theo`],
    "TEXT_SORT_ORDER": [`Sort order`, `Thứ tự sắp xếp`],
    "TEXT_PRICE": [`Price`, `Giá`],
    "TEXT_TOTAL_VIEWS": [`Total Views`, `Tổng lượt xem`],
    "TEXT_CREATED_DATE": [`Created date`, `Ngày tạo`],
    "TEXT_EIT_CREATE": [`EIT create`, `Ngày tạo EIT`],
    "TEXT_EIT_UPDATE": [`EIT update`, `Ngày update EIT`],
    "TEXT_LAST_CHECK_HEY": [`Last Check Hey`, `Cập nhật Hey`],
    "TEXT_FOUND_X_LISTINGS": [`Found [@] listings`, `Tìm thấy [@] sản phẩm`],
    "TEXT_FLOATING_SEARCH_FILTER": [`Floating Search Filter`, `Hiển thị Thanh tìm kiếm nổi`],
    "TEXT_PREVIOUS": [`Previous`, `Trước`],
    "TEXT_NEXT": [`Next`, `Sau`],
    "TEXT_DAY": [`day`, `ngày`],
    "TEXT_DAYS": [`days`, `ngày`],
    "TEXT_WEEK": [`week`, `tuần`],
    "TEXT_WEEKS": [`weeks`, `tuần`],
    "TEXT_MONTH": [`month`, `tháng`],
    "TEXT_MONTHS": [`months`, `tháng`],
    "TEXT_DECREASE": [`Decrease`, `Giảm dần`],
    "TEXT_INCREASE": [`Increase`, `Tăng dần`],
    "TEXT_CREATED": [`Created`, `Ngày tạo`],
    "TEXT_SEARCH_AND_FILTER": [`Search & Filter`, `Tìm kiếm & Lọc`],
    "TEXT_COMPETITOR_ANALYSIS": [`Competitor Analysis`, `Phân tích đối thủ`],
    "TEXT_VISIT_SHOP_X": [`Visit shop [@]`, `Xem shop [@]`],
    "TEXT_LISTING": [`Listing`, `Sản phẩm`],
    "TEXT_COLLECTION_DETAIL": [`Collection Detail`, `Chi tiết bộ sưu tập`],
    "TEXT_COLLECTION": [`Collection`, `Bộ sưu tập`],
    "TEXT_SHOP": [`Shop`, `Shop`],
    "TEXT_BOT": [`Bot`, `Bot`],
    "TEXT_3D_TOOL": [`3D Tool`, `Tool 3D`],
    "TEXT_BOX_MAKER": [`Box Maker`, `Vẽ Hộp`],
    "TEXT_DESIGN_LAMP_TOOL": [`Design Lamp Tool`, `Tool thiết kế đèn`],
    "TEXT_DASHBOARD": [`Dashboard`, `Dashboard`],
    "TEXT_USER_PROFILE": [`User Profile`, `Người dùng`],
    "TEXT_ENTER_KEYWORD": [`Enter keyword`, `Nhập từ khóa`],
    "TEXT_RUNNING_TASKS": [`Running Tasks`, `Tác vụ đang chạy`],
    "TEXT_AUTOMATICALLY_UPDATE_IN_X_SECONDS": [`Automatically update in [@] seconds`, `Tự động cập nhật sau [@] giây`],
    "TEXT_JOB": [`Job`, `Công việc`],
    "TEXT_STEP": [`Step`, `Bước`],
    "TEXT_STATUS": [`Status`, `Trạng thái`],
    "TEXT_PROGRESS": [`Progress`, `Tiến độ`],
    "TEXT_RUNNING_TIME": [`Running time`, `Thời gian chạy`],
    "TEXT_LAST_ACTIVITY": [`Last activity`, `Hoạt động lần cuối`],
    "TEXT_ACTION": [`Action`, `Hoạt động`],
    "TEXT_ASSIGN_JOB": [`Assign Job`, `Giao Việc`],
    "TEXT_X_HOURS_Y_MINUTES": [`[@] hours [@] minutes`, `[@] giờ [@] phút`],
    "TEXT_X_MINUTES_AGO": [`[@] minutes ago`, `[@] phút trước`],
    "TEXT_A_FEW_SECONDS_AGO": [`a few seconds ago`, `một vài giây trước`],
    "TEXT_X_HOURS_AGO": [`[@] hours ago`, `[@] giờ trước`],
    "TEXT_PING_TIME": [`Ping time`, `Thời gian ping`],
    "TEXT_CHECKIN_TIME": [`Checkin time`, `Thời gian checkin`],
    "TEXT_SCHEDULED_TASKS": [`Scheduled Tasks`, `Tác Vụ Lên Lịch`],
    "TEXT_SEARCH_KEYWORD": [`Search Keyword`, `Tìm Theo Từ Khóa`],
    "TEXT_SEARCH_TAG": [`Search Tag`, `Tìm Theo Tag`],
    "TEXT_SEARCH_BY_CATEGORY": [`Search By Category`, `Tìm Theo Danh Mục`],
    "TEXT_LISTINGS___SHOPS": [`Listings / Shops`, `Phân tích Sản phẩm / Cửa hàng`],
    "TEXT_TOTAL_SALES": ["Total sold", 'Tổng đơn'],
    "TEXT_SHOP_SOLD_30_DAYS": ["Sold 30 days", "Đơn 30 ngày"],
    "TEXT_SHOP_SOLD_90_DAYS": ["Sold 90 days", "Đơn 90 ngày"],
    "TEXT_RATING": ["Rating", "Rating"],
    "TEXT_OPENING_DATE": ["Opening Date", "Mở shop"],
    "TEXT_FOUND_X_SHOPS": [`Found [@] shops`, `Tìm thấy [@] cửa hàng`],
    "TEXT_MIN": ["Min", "Nhỏ nhất"],
    "TEXT_MAX": ["Max", "Lớn nhất"],
    "TEXT_LAST_SOLD_DAYS": ["Last sold days", "Đơn gần nhất"],
    "TEXT_TOTAL_LISTINGS": ["Total listings", "Số listing"],
    "TEXT_HOUR": ["hour", "giờ"],
    "TEXT_SOLD_CHART": ["Sold Chart", "Biển Đồ Sold"],
    "TEXT_IMAGE": ["Image", "Ảnh"],
    "TEXT_SKU_CODE": ["SKU Code", "Mã SKU"],
    "TEXT_SIZE": ["Size", "Kích cỡ"],
    "TEXT_STYLE": ["Style", "Kiểu dáng"],
    "TEXT_PRODUCT_NAME": ["Product Name", "Tên sản phẩm"],
    "TEXT_BASE_PRICE": ["Base Price", "Giá gốc"],
    "TEXT_CURRENT_QUANTITY": ["Current Quantity", "Tồn kho hiện tại"],
    "TEXT_MATERIAL": ["Material", "Chất liệu"],
    "TEXT_COLOR": ["Color", "Màu sắc"],
    "TEXT_DIMENSIONS": ["Dimensions", "Kích thước"],
    "TEXT_WEIGHT": ["Weight", "Khối lượng"],
    "TEXT_ACTIONS": ["Actions", "Thao tác"],
    "TEXT_VIEW": ["View", "Xem"],
    "TEXT_EDIT": ["Edit", "Sửa"],
    "TEXT_VERSIONS": ["Versions", "Version"],
    "TEXT_CLONE": ["Clone", "Nhân bản"],
    "TEXT_DELETE": ["Delete", "Xóa"],
    "TEXT_ADD_NEW_PRODUCT": ["Add New Product", "Thêm Sản Phẩm Mới"],
    "TEXT_PRODUCT_LIST": ["Product List", "Danh Sách Sản Phẩm"],
    "TEXT_PRODUCT_CODE": ["Product Code", "Mã Sản Phẩm"],
    "TEXT_PRODUCT_VERSION": ["Product Version", "Version Sản Phẩm"],
    "TEXT_PROPERTIES": ["Properties", "Thuộc tính"],
    "TEXT_IMAGES": ["Images", "Ảnh"],
    "TEXT_CLOSE": ["Close", "Đóng"],
    "TEXT_SAVE": ["Save", "Lưu"],
    "TEXT_VERSION": ["Version", "Version"],
    "TEXT_FRIENDLY_VERSION": ["Friendly Version", "Mã Version"],
    "TEXT_NOTE": ["Note", "Ghi chú"],
    "TEXT_LENGTH": ["Length (mm)", "Rộng (mm)"],
    "TEXT_WIDTH": ["Width (mm)", "Dày (mm)"],
    "TEXT_HEIGHT": ["Height (mm)", "Cao (mm)"],
    "TEXT_WAREHOUSE_ID": ["Warehouse ID", "Kho"],
    "TEXT_IMAGE_URL": ["Image URL", "Đường dẫn ảnh"],
    "TEXT_IMAGE_DESCRIPTION": ["Image Description", "Mô tả ảnh"],
    "TEXT_UPDATE_IMAGE": ["Update Image", "Cập nhật ảnh"],
    "TEXT_ADD_IMAGE": ["Add Image", "Thêm ảnh"],
    "TEXT_REMOVE": ["Remove", "Xóa"],
    "TEXT_PRODUCT": ["Product", "Sản phẩm"],
    "TEXT_SALE": ["Sale", "Bán hàng"],
    "TEXT_ADS": ["Ads", "Quảng cáo"],
    "TEXT_SALE_NGACH": ["Sale Ngách", "Sale Ngách"],
    "TEXT_SCAN_ORDERS": ["Scan Orders", "Quét đơn"],
    "TEXT_ORDER_LIST": ["Order List", "Danh sách đơn"],
    "TEXT_FULFILL": ["Fulfill", "Vận hành"],
    "TEXT_FACTORY": ["Factory", "Xưởng"],
    "TEXT_TABLE_LIST": ["Table List", "Bảng dữ liệu"],
    "TEXT_TYPOGRAPHY": ["Typography", "Kiểu chữ"],
    "TEXT_ICONS": ["Icons", "Biểu tượng"],
    "TEXT_IMPORT": ["Import", "Nhập hàng"],
    "TEXT_EXPORT": ["Export", "Xuất hàng"],
    "TEXT_QUANTITY_CHANGE": ["Quantity Change", "Lịch sử kho"],
    "TEXT_TRANSACTIONS": ["Transactions", "Lịch sử giao nhận"],
    "TEXT_INVENTORY": ["Inventory", "Kho hàng"],
    "TEXT_PRODUCT_UPDATED": ["Product updated successfully!", "Sản phẩm đã được cập nhật thành công!"],
    "TEXT_PRODUCT_CREATED": ["Product created successfully!", "Sản phẩm đã được tạo thành công!"],
    "TEXT_SAVE_FAILED": ["Failed to save product. Please try again!", "Lưu sản phẩm thất bại. Vui lòng thử lại!"],
    "TEXT_IMAGE_ADDED": ["Image added successfully!", "Đã thêm ảnh thành công!"],
    "TEXT_IMAGE_REMOVED": ["Image removed successfully!", "Đã xóa ảnh thành công!"],
    "TEXT_IMAGE_UPDATED": ["Image updated successfully!", "Đã cập nhật ảnh thành công!"],
    "TEXT_LOGIN": ["Login", "Đăng nhập"],
    "TEXT_LOGIN_DESCRIPTION": ["Please enter your login and password!", "Vui lòng nhập tài khoản và mật khẩu!"],
    "TEXT_USERNAME": ["Username", "Tên đăng nhập"],
    "TEXT_PASSWORD": ["Password", "Mật khẩu"],
    "TEXT_ENTER_USERNAME": ["Enter username", "Nhập tên đăng nhập"],
    "TEXT_ENTER_PASSWORD": ["Password", "Mật khẩu"],
    "TEXT_SET_NEW_PASSWORD": ["Set New Password", "Đặt mật khẩu mới"],
    "TEXT_NEW_PASSWORD": ["New Password", "Mật khẩu mới"],
    "TEXT_CONFIRM_NEW_PASSWORD": ["Confirm New Password", "Xác nhận mật khẩu mới"],
    "TEXT_SET_PASSWORD": ["Set Password", "Đặt mật khẩu"],
    "TEXT_PASSWORD_SET_SUCCESS": ["Password set successfully!", "Đặt mật khẩu thành công!"],
    "TEXT_PASSWORDS_DO_NOT_MATCH": ["New passwords do not match", "Mật khẩu nhập lại không khớp"],
    "TEXT_PASSWORD_TOO_SHORT": ["New password must be at least 6 characters long", "Mật khẩu mới phải có ít nhất 6 ký tự"],
    "TEXT_FAILED_SET_PASSWORD": ["Failed to set password", "Đặt mật khẩu thất bại"],
    "TEXT_MY_ACCOUNT": ["My Account", "Tài khoản"],
    "TEXT_FULL_NAME": ["Full Name", "Họ tên"],
    "TEXT_ACTIVE": ["Active", "Đang hoạt động"],
    "TEXT_INACTIVE": ["Inactive", "Không hoạt động"],
    "TEXT_CREATED_AT": ["Created At", "Ngày tạo"],
    "TEXT_UPDATED_AT": ["Updated At", "Thời gian cập nhật"],
    "TEXT_GROUPS": ["Groups", "Nhóm"],
    "TEXT_CHANGE_PASSWORD": ["Change Password", "Đổi mật khẩu"],
    "TEXT_LOGOUT": ["Logout", "Đăng xuất"],
    "TEXT_LOADING": ["Loading...", "Đang tải..."],
    "TEXT_PASSWORD_CHANGED_SUCCESS": ["Password changed successfully!", "Đổi mật khẩu thành công!"],
    "TEXT_FAILED_CHANGE_PASSWORD": ["Failed to change password. Please check your current password.", "Đổi mật khẩu thất bại. Vui lòng kiểm tra mật khẩu hiện tại."],
    "TEXT_CURRENT_PASSWORD": ["Current Password", "Mật khẩu hiện tại"],
    "TEXT_AUTOECOM_ADS": ["Smart Ads", "Smart Ads"],
    "TEXT_ID": ["ID", "ID"],
    "TEXT_LAST_PING": ["Last Ping", "Ping gần nhất"],
    "TEXT_CONFIG_ADS": ["Config Ads", "Cấu hình Ads"],
    "TEXT_BASE_VALUE": ["Base Value", "Giá trị base"],
    "TEXT_START_HOUR": ["Start Hour", "Giờ bắt đầu"],
    "TEXT_END_HOUR": ["End Hour", "Giờ kết thúc"],
    "TEXT_SAVE_CONFIG": ["Save Config", "Lưu cấu hình"],
    "TEXT_VIEW_CONFIG_HISTORY": ["View Config History", "Xem lịch sử config"],
    "TEXT_CONFIG_HISTORY": ["Config History", "Lịch sử cấu hình"],
    "TEXT_TODAY": ["Today", "Hôm nay"],
    "TEXT_YESTERDAY": ["Yesterday", "Hôm qua"],
    "TEXT_ORDERS": ["Orders", "Đơn hàng"],
    "TEXT_CONFIRM_SELECTED": ["Confirm Selected", "Xác nhận đã chọn"],
    "TEXT_CANCEL_SELECTED": ["Cancel Selected", "Hủy đã chọn"],
    "TEXT_SET_TO_PENDING": ["Set to Pending", "Chuyển về chờ xử lý"],
    "TEXT_CONFIG_VIEW": ["Config View", "Cấu hình hiển thị"],
    "TEXT_DELETE_ORDER": ["Delete Order", "Xóa đơn"],
    "TEXT_CANCEL": ["Cancel", "Hủy"],
    "TEXT_SAVE_CHANGES": ["Save Changes", "Lưu thay đổi"],
    "TEXT_SAVE_VIEW": ["Save View", "Lưu cấu hình"],
    "TEXT_QUANTITY_CHANGE_HISTORY": ["Quantity Change History", "Lịch sử thay đổi số lượng"],
    "TEXT_WAREHOUSE": ["Warehouse", "Kho"],
    "TEXT_CHANGE_AMOUNT": ["Change Amount", "Số lượng thay đổi"],
    "TEXT_UPDATED_QUANTITY": ["Updated Quantity", "Tồn kho sau thay đổi"],
    "TEXT_TYPE": ["Type", "Loại"],
    "TEXT_REFERENCE_ID": ["Reference ID", "Mã tham chiếu"],
    "TEXT_STAFF_NOTE": ["Staff Note", "Ghi chú nhân viên"],
    "TEXT_UPDATED_BY": ["Updated By", "Người cập nhật"],
    "TEXT_DATE": ["Date", "Ngày"],
    "TEXT_ADD_NEW_CHANGE": ["Add New Change", "Thêm thay đổi mới"],
    "TEXT_ADD_NEW_QUANTITY_CHANGE": ["Add New Quantity Change", "Thêm thay đổi số lượng mới"],
    "TEXT_VIEW_QUANTITY_CHANGE": ["View Quantity Change", "Xem thay đổi số lượng"],
    "TEXT_EDIT_QUANTITY_CHANGE": ["Edit Quantity Change", "Sửa thay đổi số lượng"],
    "TEXT_OLD_QUANTITY": ["Old Quantity", "Tồn kho cũ"],
    "TEXT_NEW_QUANTITY": ["New Quantity", "Tồn kho mới"],
    "TEXT_SYSTEM_NOTE": ["System Note", "Ghi chú hệ thống"],
    "TEXT_ORDER_DATE": ["Order Date", "Ngày đặt hàng"],
    "TEXT_ORDER_ID": ["Order ID", "Mã đơn Etsy"],
    "TEXT_CUSTOMER": ["Customer", "Khách hàng"],
    "TEXT_BUYER_NOTE": ["Buyer Note", "Ghi chú người mua"],
    "TEXT_SELLER_NOTE": ["Seller Note", "Ghi chú người bán"],
    "TEXT_EST_DELIVERY": ["Est. Delivery", "Dự kiến giao hàng"],
    "TEXT_SHIPPING_ADDRESS": ["Shipping Address", "Địa chỉ giao hàng"],
    "TEXT_EMAIL": ["Email", "Email"],
    "TEXT_EDIT_LISTING_ORDER_NOTE": ["Edit Listing / Order Note", "Sửa thông tin sản phẩm / Ghi chú đơn hàng"],
    "TEXT_LISTING_DETAILS": ["Listing Details", "Chi tiết sản phẩm"],
    "TEXT_ORDER_NOTES": ["Order Notes", "Ghi chú đơn hàng"],
    "TEXT_CONFIGURE_VIEW_COLUMNS": ["Configure View Columns", "Cấu hình cột hiển thị"],
    "TEXT_THIS_WEEK": ["This week", "Tuần này"],
    "TEXT_LAST_WEEK": ["Last week", "Tuần trước"],
    "TEXT_THIS_MONTH": ["This month", "Tháng này"],
    "TEXT_LAST_MONTH": ["Last month", "Tháng trước"],
    "TEXT_TOTAL_ORDERS": ["Total orders", "Tổng số đơn"],
    "TEXT_SHOWING": ["Showing", "Đang hiển thị"],
    "TEXT_NO_ORDERS_FOUND": ["No orders found", "Không có đơn hàng nào"],
    "TEXT_ITEMS_PER_PAGE": ["Items per page", "Số dòng/trang"],
    "TEXT_PAGE": ["Page", "Trang"],
    "TEXT_BULK_UPDATE_STATUS": ["Bulk Update Status", "Cập nhật hàng loạt"],
    "TEXT_ORDERS_SELECTED": ["orders selected", "đơn đã chọn"],
    "TEXT_CANCELLED": ["Cancelled", "Đã hủy"],
    "TEXT_WAITING_FOR_PAYMENT": ["Waiting for Payment", "Chờ thanh toán"],
    "TEXT_WAIT_FOR_PROCESSING": ["Wait for Processing", "Chờ xử lý"],
    "TEXT_PROCESSING": ["Processing", "Đang xử lý"],
    "TEXT_PROCESSING_CUSTOM_ORDER": ["Processing Custom Order", "Xử lý đơn custom"],
    "TEXT_FULFILL_PROCESSING": ["Fulfill Processing", "Đang xử lý fulfill"],
    "TEXT_PACKAGING": ["Packaging", "Đang đóng hàng"],
    "TEXT_DONE_PACKAGING": ["Done Packaging", "Đã đóng hàng xong"],
    "TEXT_SHIPPED_TO_SHIPPING_CENTER": ["Shipped to Shipping Center", "Đã ship cho ĐVVC"],
    "TEXT_SHIPPED_TO_CUSTOMER": ["Shipped to Customer", "Đã ship cho khách"],
    "TEXT_CUSTOMS_HOLD": ["Customs Hold", "Bị hải quan giữ"],
    "TEXT_RETURNED_TO_SHIPPING_WAREHOUSE": ["Returned to Shipping Warehouse", "Đã trả về kho ĐVVC"],
    "TEXT_RETURNED_TO_SHIPPING_CENTER": ["Returned to Shipping Center", "Đã trả về ĐVVC"],
    "TEXT_RETURNED_TO_WAREHOUSE": ["Returned to Warehouse", "Đã trả về kho"],
    "TEXT_COMPLETED": ["Completed", "Hoàn thành"],
    "TEXT_REFUNDED": ["Refunded", "Đã hoàn tiền"],
    "TEXT_APPLY": ["Apply", "Áp dụng"],
    "TEXT_PRIORITY": ["Priority", "Độ ưu tiên"],
    "TEXT_PRIORITY_LOW": ["Low", "Thấp"],
    "TEXT_PRIORITY_MEDIUM": ["Medium", "Trung bình"],
    "TEXT_PRIORITY_HIGH": ["High", "Cao"],
    "TEXT_PRIORITY_EXPRESS": ["Express", "Hoả tốc"],
    "TEXT_RND_TITLE": ["Smart RnD", "Smart RnD"],
    "TEXT_RND_PRODUCT": ["RnD Product", "Sản phẩm"],
    "TEXT_RND_ORDER_LIST": ["Custom Orders", "Đơn custom"],
    "TEXT_EIT": ["EIT", "EIT"],
    "TEXT_SALE_TITLE": ["Smart Sale", "Smart Sale"],
    "TEXT_SALE_ORDER_LIST": ["Etsy Orders", "Đơn Etsy"],
    "TEXT_SALE_STATS": ["Sale Statistics", "Thống kê sale"],
    "TEXT_FULFILL_TITLE": ["Smart Fulfill", "Smart Fulfill"],
    "TEXT_FULFILL_ORDER_LIST": ["Fulfill Orders", "Đơn Fulfill"],
    "TEXT_HISTORY": ["History", "Lịch sử"],
    "TEXT_HISTORY_WAREHOUSE": ["Warehouse History", "Lịch sử xuất nhập"],
    "TEXT_HISTORY_DELIVERY": ["Delivery History", "Lịch sử giao nhận"],
    "TEXT_ADMIN_TITLE": ["Smart Admin", "Smart Admin"],
    "TEXT_BOD_TITLE": ["Smart BOD", "Smart BOD"],
    "TEXT_PERMISSION_MANAGEMENT": ["Permission Management", "Quản lý quyền"],
    "TEXT_PERMISSIONS": ["Permissions", "Phân quyền"],
    "TEXT_USER_GROUPS": ["User Groups", "Nhóm người dùng"],
    "TEXT_USERS": ["Users", "Người dùng"],
    "TEXT_K3DOC_VIEW": ["K3Doc View", "Xem K3Doc"],
    "TEXT_K3DOC_LIST": ["K3Doc List", "Danh sách K3Doc"],
    "TEXT_VERSION_NOTIFICATION": ["Version Notification", "Phiên bản mới"],
    "TEXT_ROOT_TITLE": ["Smart Root", "Smart Root"],
    "TEXT_EDIT_TRANSACTION": ["Edit Transaction", "Sửa giao dịch"],
    "TEXT_CREATE_TRANSACTION": ["Create Transaction", "Tạo giao dịch"],
    "TEXT_TOTAL_PRODUCTS": ["Total products", "Tổng số sản phẩm"],
    "TEXT_MONTHLY_ID": ["Monthly ID", "Mã đơn"],
    "TEXT_IMPORT_EXPORT_TITLE": ["Import/Export Products", "Nhập/Xuất Sản Phẩm"],
    "TEXT_SELECT_PARTNER": ["Select a partner", "Chọn đối tác"],
    "TEXT_PRODUCT_CODE": ["Product Code", "Mã Sản Phẩm"],
    "TEXT_QUANTITY": ["Quantity", "Số Lượng"],
    "TEXT_ACTION": ["Action", "Thao Tác"],
    "TEXT_ADD_ITEM": ["Add Item", "Thêm Sản Phẩm"],
    "TEXT_ENTER_NOTE": ["Enter any additional notes...", "Nhập ghi chú thêm..."],
    "TEXT_SAVING": ["Saving...", "Đang lưu..."],
    "TEXT_PLEASE_SELECT_WAREHOUSE": ["Please select a warehouse", "Vui lòng chọn kho"],
    "TEXT_PLEASE_FILL_ALL": ["Please fill in all product codes and quantities", "Vui lòng điền đầy đủ mã sản phẩm và số lượng"],
    "TEXT_SUCCESSFULLY_SAVED": ["Successfully saved transaction", "Lưu giao dịch thành công"],
    "TEXT_FAILED_SAVE": ["Failed to save transaction. See console for details.", "Lưu giao dịch thất bại. Xem chi tiết trong console."],
    "TEXT_ADD_LISTING": ["Add Listing", "+Listing"],
    "TEXT_ADD_ORDER": ["Add Order", "Thêm đơn"],
    "TEXT_ADD_NEW_ORDER": ["Add New Order", "Thêm đơn mới"],
    "TEXT_ADDED_REASON": ["Added Reason", "Lý do thêm đơn"],
    "TEXT_ETSY_NEW_ORDER": ["Etsy New Order", "Đơn mới"],
    "TEXT_ETSY_WARRANTY_ORDER": ["Etsy Warranty Order", "Đơn bảo hành"],
    "TEXT_NON_ETSY_ORDER": ["Non Etsy Order", "Đơn ngoài Etsy"],
    "TEXT_TOTAL_QUANTITY": ["Total Quantity", "Tổng số lượng"],
    "TEXT_TOTAL_ITEMS": ["Total Items", "Tổng số sản phẩm"],
    "TEXT_TRANSACTION_DETAILS": ["Transaction Details", "Chi tiết giao dịch"],
    "TEXT_TRANSACTION_ID": ["Transaction ID", "Mã giao dịch"],
    "TEXT_PARTNER": ["Partner", "Đối tác"],
    "TEXT_SYSTEM_NOTE": ["System Note", "Ghi chú hệ thống"],
    "TEXT_STAFF_NOTE": ["Staff Note", "Ghi chú nhân viên"],
    "TEXT_INVENTORY_TRANSACTIONS": ["Inventory Transactions", "Lịch sử xuất nhập kho"],
    "TEXT_SEARCH_TRANSACTIONS": ["Search transactions...", "Tìm kiếm giao dịch..."],
    "TEXT_IMPORT_PRODUCTS": ["Import Products", "Nhập hàng"],
    "TEXT_EXPORT_PRODUCTS": ["Export Products", "Xuất hàng"],
    "TEXT_CREATED_AT": ["Created At", "Ngày tạo"],
    "TEXT_ACTIONS": ["Actions", "Thao tác"],
    "TEXT_VIEW": ["View", "Xem"],
    "TEXT_PREVIOUS_PAGE": ["Previous Page", "Trang trước"],
    "TEXT_NEXT_PAGE": ["Next Page", "Trang sau"],
    "TEXT_PAGE": ["Page", "Trang"],
    "TEXT_LOADING_TRANSACTIONS": ["Loading transactions...", "Đang tải giao dịch..."],
    "TEXT_PRINT": ["Print", "In"],
    "TEXT_VIEW_WAREHOUSE": ["View Warehouse", "Xem kho hàng"],
    "TEXT_SHIPPABLE_ORDERS": ["Shippable Orders", "Đơn có thể ship"],
    "TEXT_WAREHOUSE_LAMPS": ["Warehouse Lamps", "Đèn xuất kho"],
    "TEXT_OUT_OF_STOCK_LAMPS": ["Out of Stock Lamps", "Đèn thiếu"],
    "TEXT_TOTAL_ORDERS": ["Total Orders", "Tổng số đơn"],
    "TEXT_TOTAL_LAMPS": ["Total Lamps", "Tổng số đèn"],
    "TEXT_ORDER_DATE": ["Order Date", "Ngày đặt hàng"],
    "TEXT_MONTHLY_ID": ["Monthly ID", "Mã đơn"],
    "TEXT_ORDER_ID": ["Order ID", "Mã đơn hàng"],
    "TEXT_SHOP": ["Shop", "Shop"],
    "TEXT_CUSTOMER": ["Customer", "Khách hàng"],
    "TEXT_SKU": ["SKU", "SKU"],
    "TEXT_IMAGE": ["Image", "Ảnh"],
    "TEXT_NAME": ["Name", "Tên"],
    "TEXT_SIZE": ["Size", "Kích cỡ"],
    "TEXT_BUYER_NOTE": ["Customer Note", "Ghi chú khách"],
    "TEXT_USER_NOTE": ["User Note", "Ghi chú nhân viên"],
    "TEXT_ADDRESS": ["Address", "Địa chỉ"],
    "TEXT_CELL_CODE": ["Cell Code", "Vị trí"],
    "TEXT_QUANTITY": ["Quantity", "Số lượng"],
    "TEXT_IOSS": ["IOSS", "Mã IOSS"],
    "TEXT_AVAILABLE": ["Available", "Check kho"],
    "TEXT_INVENTORY_CHECK": ["Inventory Check", "Kiểm kê kho"],
    "TEXT_AVAILABLE_PENDING": ["Pending", "Đang chờ"],
    "TEXT_AVAILABLE_IN_STOCK": ["In Stock", "Còn hàng"],
    "TEXT_AVAILABLE_OUT_OF_STOCK": ["Out of Stock", "Hết hàng"],
    "TEXT_AVAILABLE_RESERVED": ["Reserved", "Đặt trước"],
    "TEXT_AVAILABLE_UNKNOWN": ["Unknown", "Không xác định"],
    "TEXT_SHIPPING_CENTER_DATE": ["Shipping Center Date", "Ngày ship ĐVVC"],
    "TEXT_FULFILL_PROCESSING": ["Fulfill Processing", "Đang xử lý fulfill"],
    "TEXT_PACKAGING": ["Packaging", "Đang đóng hàng"],
    "TEXT_CURRENT_CELL_CODE": ["Current Cell Code", "Vị trí kho"],
    "TEXT_QUANTITY_CHANGE_HISTORY_FOR": ["Quantity Change History for", "Lịch sử thay đổi số lượng của"],
    "TEXT_NO_QUANTITY_CHANGES": ["No quantity changes found", "Không có lịch sử thay đổi số lượng"],
    "TEXT_QUANTITY_CHANGE_ADDED": ["Quantity change added successfully", "Đã thêm thay đổi số lượng thành công"],
    "TEXT_QUANTITY_CHANGE_UPDATED": ["Quantity change updated successfully", "Đã cập nhật thay đổi số lượng thành công"],
    "TEXT_QUANTITY_CHANGE_DELETED": ["Quantity change deleted successfully", "Đã xóa thay đổi số lượng thành công"],
    "TEXT_QUANTITY_CHANGE_FAILED": ["Failed to save quantity change", "Lưu thay đổi số lượng thất bại"],
    "TEXT_QUANTITY_CHANGE_CONFIRM_DELETE": ["Are you sure you want to delete this quantity change?", "Bạn có chắc chắn muốn xóa thay đổi số lượng này?"],
    "TEXT_QUANTITY_CHANGE_CONFIRM_UPDATE": ["Are you sure you want to update this quantity change?", "Bạn có chắc chắn muốn cập nhật thay đổi số lượng này?"],
    "TEXT_QUANTITY_CHANGE_CONFIRM_ADD": ["Are you sure you want to add this quantity change?", "Bạn có chắc chắn muốn thêm thay đổi số lượng này?"],
    "TEXT_QUANTITY_CHANGE_TYPE_IN": ["In", "Nhập kho"],
    "TEXT_QUANTITY_CHANGE_TYPE_OUT": ["Out", "Xuất kho"],
    "TEXT_QUANTITY_CHANGE_TYPE_ADJUST": ["Adjust", "Điều chỉnh"],
    "TEXT_QUANTITY_CHANGE_TYPE_RETURN": ["Return", "Trả hàng"],
    "TEXT_QUANTITY_CHANGE_TYPE_DAMAGE": ["Damage", "Hư hỏng"],
    "TEXT_QUANTITY_CHANGE_TYPE_OTHER": ["Other", "Khác"],
    "TEXT_QUANTITY_CHANGE_TYPE_IMPORT": ["Import", "Nhập kho"],
    "TEXT_QUANTITY_CHANGE_TYPE_EXPORT": ["Export", "Xuất kho"],
    "TEXT_QUANTITY_CHANGE_TYPE_INVENTORY_CHECK": ["Inventory Check", "Kiểm kê kho"],
    "TEXT_DISPLAY_CONFIG": ["Display Configuration", "Cấu hình hiển thị"],
    "TEXT_REVENUE_30_DAYS": ["Revenue 30 days", "Doanh thu 30 ngày"],
    "TEXT_SALE_RATIO": ["Sale ratio", "Tỉ lệ bán/view"],
};

export const LANGUAGE_KEYS = {
    "TEXT_TITLE": "TEXT_TITLE",
    "TEXT_GREETING": `TEXT_GREETING`,
    "TEXT_BOT_ID": `TEXT_BOT_ID`,
    "TEXT_JOB_ID": `TEXT_JOB_ID`,
    "TEXT_ALL": `TEXT_ALL`,
    "TEXT_TASK": `TEXT_TASK`,
    "TEXT_FROM": `TEXT_FROM`,
    "TEXT_SEARCH": `TEXT_SEARCH`,
    "TEXT_DAILY_VIEW": `TEXT_DAILY_VIEW`,
    "TEXT_PRICE_MIN": `TEXT_PRICE_MIN`,
    "TEXT_PRICE_MAX": `TEXT_PRICE_MAX`,
    "TEXT_SOLD_30_CALCULATE": `TEXT_SOLD_30_CALCULATE`,
    "TEXT_REVENUE_30_CALCULATE": `TEXT_REVENUE_30_CALCULATE`,
    "TEXT_SOLD_30_COUNT": `TEXT_SOLD_30_COUNT`,
    "TEXT_REVENUE_30_COUNT": `TEXT_REVENUE_30_COUNT`,
    "TEXT_FAVORITE": `TEXT_FAVORITE`,
    "TEXT_FAVORITE_RATE": `TEXT_FAVORITE_RATE`,
    "TEXT_LAST_UPDATE": `TEXT_LAST_UPDATE`,
    "TEXT_SORT_BY": `TEXT_SORT_BY`,
    "TEXT_SORT_ORDER": `TEXT_SORT_ORDER`,
    "TEXT_PRICE": `TEXT_PRICE`,
    "TEXT_TOTAL_VIEWS": `TEXT_TOTAL_VIEWS`,
    "TEXT_CREATED_DATE": `TEXT_CREATED_DATE`,
    "TEXT_EIT_CREATE": `TEXT_EIT_CREATE`,
    "TEXT_EIT_UPDATE": `TEXT_EIT_UPDATE`,
    "TEXT_LAST_CHECK_HEY": `TEXT_LAST_CHECK_HEY`,
    "TEXT_FOUND_X_LISTINGS": `TEXT_FOUND_X_LISTINGS`,
    "TEXT_FLOATING_SEARCH_FILTER": `TEXT_FLOATING_SEARCH_FILTER`,
    "TEXT_PREVIOUS": `TEXT_PREVIOUS`,
    "TEXT_NEXT": `TEXT_NEXT`,
    "TEXT_DAY": `TEXT_DAY`,
    "TEXT_DAYS": `TEXT_DAYS`,
    "TEXT_WEEK": `TEXT_WEEK`,
    "TEXT_WEEKS": `TEXT_WEEKS`,
    "TEXT_MONTH": `TEXT_MONTH`,
    "TEXT_MONTHS": `TEXT_MONTHS`,
    "TEXT_DECREASE": `TEXT_DECREASE`,
    "TEXT_INCREASE": `TEXT_INCREASE`,
    "TEXT_CREATED": `TEXT_CREATED`,
    "TEXT_SEARCH_AND_FILTER": `TEXT_SEARCH_AND_FILTER`,
    "TEXT_COMPETITOR_ANALYSIS": `TEXT_COMPETITOR_ANALYSIS`,
    "TEXT_VISIT_SHOP_X": `TEXT_VISIT_SHOP_X`,
    "TEXT_LISTING": `TEXT_LISTING`,
    "TEXT_COLLECTION_DETAIL": `TEXT_COLLECTION_DETAIL`,
    "TEXT_COLLECTION": `TEXT_COLLECTION`,
    "TEXT_SHOP": `TEXT_SHOP`,
    "TEXT_BOT": `TEXT_BOT`,
    "TEXT_3D_TOOL": `TEXT_3D_TOOL`,
    "TEXT_BOX_MAKER": "TEXT_BOX_MAKER",
    "TEXT_DESIGN_LAMP_TOOL": `TEXT_DESIGN_LAMP_TOOL`,
    "TEXT_DASHBOARD": `TEXT_DASHBOARD`,
    "TEXT_USER_PROFILE": `TEXT_USER_PROFILE`,
    "TEXT_ENTER_KEYWORD": `TEXT_ENTER_KEYWORD`,
    "TEXT_RUNNING_TASKS": `TEXT_RUNNING_TASKS`,
    "TEXT_AUTOMATICALLY_UPDATE_IN_X_SECONDS": `TEXT_AUTOMATICALLY_UPDATE_IN_X_SECONDS`,
    "TEXT_JOB": `TEXT_JOB`,
    "TEXT_STEP": `TEXT_STEP`,
    "TEXT_STATUS": `TEXT_STATUS`,
    "TEXT_PROGRESS": `TEXT_PROGRESS`,
    "TEXT_RUNNING_TIME": `TEXT_RUNNING_TIME`,
    "TEXT_LAST_ACTIVITY": `TEXT_LAST_ACTIVITY`,
    "TEXT_ACTION": `TEXT_ACTION`,
    "TEXT_ASSIGN_JOB": `TEXT_ASSIGN_JOB`,
    "TEXT_X_HOURS_Y_MINUTES": `TEXT_X_HOURS_Y_MINUTES`,
    "TEXT_X_MINUTES_AGO": `TEXT_X_MINUTES_AGO`,
    "TEXT_A_FEW_SECONDS_AGO": `TEXT_A_FEW_SECONDS_AGO`,
    "TEXT_X_HOURS_AGO": `TEXT_X_HOURS_AGO`,
    "TEXT_PING_TIME": `TEXT_PING_TIME`,
    "TEXT_CHECKIN_TIME": `TEXT_CHECKIN_TIME`,
    "TEXT_SCHEDULED_TASKS": `TEXT_SCHEDULED_TASKS`,
    "TEXT_SEARCH_KEYWORD": `TEXT_SEARCH_KEYWORD`,
    "TEXT_SEARCH_TAG": `TEXT_SEARCH_TAG`,
    "TEXT_SEARCH_BY_CATEGORY": `TEXT_SEARCH_BY_CATEGORY`,
    "TEXT_LISTINGS___SHOPS": `TEXT_LISTINGS___SHOPS`,
    "TEXT_TOTAL_SALES": "TEXT_TOTAL_SALES",
    "TEXT_SHOP_SOLD_30_DAYS": "TEXT_SHOP_SOLD_30_DAYS",
    "TEXT_SHOP_SOLD_90_DAYS": "TEXT_SHOP_SOLD_90_DAYS",
    "TEXT_RATING": "TEXT_RATING",
    "TEXT_OPENING_DATE": "TEXT_OPENING_DATE",
    "TEXT_FOUND_X_SHOPS": `TEXT_FOUND_X_SHOPS`,
    "TEXT_LAST_SOLD_DAYS": "TEXT_LAST_SOLD_DAYS",
    "TEXT_TOTAL_LISTINGS": "TEXT_TOTAL_LISTINGS",
    "TEXT_HOUR": "TEXT_HOUR",
    "TEXT_SOLD_CHART": "TEXT_SOLD_CHART",
    "TEXT_IMAGE": "TEXT_IMAGE",
    "TEXT_SKU_CODE": "TEXT_SKU_CODE",
    "TEXT_SIZE": "TEXT_SIZE",
    "TEXT_STYLE": "TEXT_STYLE",
    "TEXT_PRODUCT_NAME": "TEXT_PRODUCT_NAME",
    "TEXT_BASE_PRICE": "TEXT_BASE_PRICE",
    "TEXT_CURRENT_QUANTITY": "TEXT_CURRENT_QUANTITY",
    "TEXT_MATERIAL": "TEXT_MATERIAL",
    "TEXT_COLOR": "TEXT_COLOR",
    "TEXT_DIMENSIONS": "TEXT_DIMENSIONS",
    "TEXT_WEIGHT": "TEXT_WEIGHT",
    "TEXT_ACTIONS": "TEXT_ACTIONS",
    "TEXT_VIEW": "TEXT_VIEW",
    "TEXT_EDIT": "TEXT_EDIT",
    "TEXT_VERSIONS": "TEXT_VERSIONS",
    "TEXT_CLONE": "TEXT_CLONE",
    "TEXT_DELETE": "TEXT_DELETE",
    "TEXT_ADD_NEW_PRODUCT": "TEXT_ADD_NEW_PRODUCT",
    "TEXT_PRODUCT_LIST": "TEXT_PRODUCT_LIST",
    "TEXT_PRODUCT_CODE": "TEXT_PRODUCT_CODE",
    "TEXT_PRODUCT_VERSION": "TEXT_PRODUCT_VERSION",
    "TEXT_PROPERTIES": "TEXT_PROPERTIES",
    "TEXT_IMAGES": "TEXT_IMAGES",
    "TEXT_CLOSE": "TEXT_CLOSE",
    "TEXT_SAVE": "TEXT_SAVE",
    "TEXT_VERSION": "TEXT_VERSION",
    "TEXT_FRIENDLY_VERSION": "TEXT_FRIENDLY_VERSION",
    "TEXT_NOTE": "TEXT_NOTE",
    "TEXT_LENGTH": "TEXT_LENGTH",
    "TEXT_WIDTH": "TEXT_WIDTH",
    "TEXT_HEIGHT": "TEXT_HEIGHT",
    "TEXT_WAREHOUSE_ID": "TEXT_WAREHOUSE_ID",
    "TEXT_IMAGE_URL": "TEXT_IMAGE_URL",
    "TEXT_IMAGE_DESCRIPTION": "TEXT_IMAGE_DESCRIPTION",
    "TEXT_UPDATE_IMAGE": "TEXT_UPDATE_IMAGE",
    "TEXT_ADD_IMAGE": "TEXT_ADD_IMAGE",
    "TEXT_REMOVE": "TEXT_REMOVE",
    "TEXT_PRODUCT": "TEXT_PRODUCT",
    "TEXT_SALE": "TEXT_SALE",
    "TEXT_ADS": "TEXT_ADS",
    "TEXT_SALE_NGACH": "TEXT_SALE_NGACH",
    "TEXT_SCAN_ORDERS": "TEXT_SCAN_ORDERS",
    "TEXT_ORDER_LIST": "TEXT_ORDER_LIST",
    "TEXT_FULFILL": "TEXT_FULFILL",
    "TEXT_FACTORY": "TEXT_FACTORY",
    "TEXT_TABLE_LIST": "TEXT_TABLE_LIST",
    "TEXT_TYPOGRAPHY": "TEXT_TYPOGRAPHY",
    "TEXT_ICONS": "TEXT_ICONS",
    "TEXT_IMPORT": "TEXT_IMPORT",
    "TEXT_EXPORT": "TEXT_EXPORT",
    "TEXT_QUANTITY_CHANGE": "TEXT_QUANTITY_CHANGE",
    "TEXT_TRANSACTIONS": "TEXT_TRANSACTIONS",
    "TEXT_INVENTORY": "TEXT_INVENTORY",
    "TEXT_PRODUCT_UPDATED": "TEXT_PRODUCT_UPDATED",
    "TEXT_PRODUCT_CREATED": "TEXT_PRODUCT_CREATED",
    "TEXT_SAVE_FAILED": "TEXT_SAVE_FAILED",
    "TEXT_IMAGE_ADDED": "TEXT_IMAGE_ADDED",
    "TEXT_IMAGE_REMOVED": "TEXT_IMAGE_REMOVED",
    "TEXT_IMAGE_UPDATED": "TEXT_IMAGE_UPDATED",
    "TEXT_LOGIN": "TEXT_LOGIN",
    "TEXT_LOGIN_DESCRIPTION": "TEXT_LOGIN_DESCRIPTION",
    "TEXT_USERNAME": "TEXT_USERNAME",
    "TEXT_PASSWORD": "TEXT_PASSWORD",
    "TEXT_ENTER_USERNAME": "TEXT_ENTER_USERNAME",
    "TEXT_ENTER_PASSWORD": "TEXT_ENTER_PASSWORD",
    "TEXT_SET_NEW_PASSWORD": "TEXT_SET_NEW_PASSWORD",
    "TEXT_NEW_PASSWORD": "TEXT_NEW_PASSWORD",
    "TEXT_CONFIRM_NEW_PASSWORD": "TEXT_CONFIRM_NEW_PASSWORD",
    "TEXT_SET_PASSWORD": "TEXT_SET_PASSWORD",
    "TEXT_PASSWORD_SET_SUCCESS": "TEXT_PASSWORD_SET_SUCCESS",
    "TEXT_PASSWORDS_DO_NOT_MATCH": "TEXT_PASSWORDS_DO_NOT_MATCH",
    "TEXT_PASSWORD_TOO_SHORT": "TEXT_PASSWORD_TOO_SHORT",
    "TEXT_FAILED_SET_PASSWORD": "TEXT_FAILED_SET_PASSWORD",
    "TEXT_MY_ACCOUNT": "TEXT_MY_ACCOUNT",
    "TEXT_FULL_NAME": "TEXT_FULL_NAME",
    "TEXT_ACTIVE": "TEXT_ACTIVE",
    "TEXT_INACTIVE": "TEXT_INACTIVE",
    "TEXT_CREATED_AT": "TEXT_CREATED_AT",
    "TEXT_UPDATED_AT": "TEXT_UPDATED_AT",
    "TEXT_GROUPS": "TEXT_GROUPS",
    "TEXT_CHANGE_PASSWORD": "TEXT_CHANGE_PASSWORD",
    "TEXT_LOGOUT": "TEXT_LOGOUT",
    "TEXT_LOADING": "TEXT_LOADING",
    "TEXT_PASSWORD_CHANGED_SUCCESS": "TEXT_PASSWORD_CHANGED_SUCCESS",
    "TEXT_FAILED_CHANGE_PASSWORD": "TEXT_FAILED_CHANGE_PASSWORD",
    "TEXT_CURRENT_PASSWORD": "TEXT_CURRENT_PASSWORD",
    "TEXT_AUTOECOM_ADS": "TEXT_AUTOECOM_ADS",
    "TEXT_ID": "TEXT_ID",
    "TEXT_LAST_PING": "TEXT_LAST_PING",
    "TEXT_CONFIG_ADS": "TEXT_CONFIG_ADS",
    "TEXT_BASE_VALUE": "TEXT_BASE_VALUE",
    "TEXT_START_HOUR": "TEXT_START_HOUR",
    "TEXT_END_HOUR": "TEXT_END_HOUR",
    "TEXT_SAVE_CONFIG": "TEXT_SAVE_CONFIG",
    "TEXT_VIEW_CONFIG_HISTORY": "TEXT_VIEW_CONFIG_HISTORY",
    "TEXT_CONFIG_HISTORY": "TEXT_CONFIG_HISTORY",
    "TEXT_TODAY": "TEXT_TODAY",
    "TEXT_YESTERDAY": "TEXT_YESTERDAY",
    "TEXT_ORDERS": "TEXT_ORDERS",
    "TEXT_CONFIRM_SELECTED": "TEXT_CONFIRM_SELECTED",
    "TEXT_CANCEL_SELECTED": "TEXT_CANCEL_SELECTED",
    "TEXT_SET_TO_PENDING": "TEXT_SET_TO_PENDING",
    "TEXT_CONFIG_VIEW": "TEXT_CONFIG_VIEW",
    "TEXT_DELETE_ORDER": "TEXT_DELETE_ORDER",
    "TEXT_CANCEL": "TEXT_CANCEL",
    "TEXT_SAVE_CHANGES": "TEXT_SAVE_CHANGES",
    "TEXT_SAVE_VIEW": "TEXT_SAVE_VIEW",
    "TEXT_QUANTITY_CHANGE_HISTORY": "TEXT_QUANTITY_CHANGE_HISTORY",
    "TEXT_WAREHOUSE": "TEXT_WAREHOUSE",
    "TEXT_CHANGE_AMOUNT": "TEXT_CHANGE_AMOUNT",
    "TEXT_UPDATED_QUANTITY": "TEXT_UPDATED_QUANTITY",
    "TEXT_TYPE": "TEXT_TYPE",
    "TEXT_REFERENCE_ID": "TEXT_REFERENCE_ID",
    "TEXT_STAFF_NOTE": "TEXT_STAFF_NOTE",
    "TEXT_UPDATED_BY": "TEXT_UPDATED_BY",
    "TEXT_DATE": "TEXT_DATE",
    "TEXT_ADD_NEW_CHANGE": "TEXT_ADD_NEW_CHANGE",
    "TEXT_ADD_NEW_QUANTITY_CHANGE": "TEXT_ADD_NEW_QUANTITY_CHANGE",
    "TEXT_VIEW_QUANTITY_CHANGE": "TEXT_VIEW_QUANTITY_CHANGE",
    "TEXT_EDIT_QUANTITY_CHANGE": "TEXT_EDIT_QUANTITY_CHANGE",
    "TEXT_OLD_QUANTITY": "TEXT_OLD_QUANTITY",
    "TEXT_NEW_QUANTITY": "TEXT_NEW_QUANTITY",
    "TEXT_SYSTEM_NOTE": "TEXT_SYSTEM_NOTE",
    "TEXT_ORDER_DATE": "TEXT_ORDER_DATE",
    "TEXT_ORDER_ID": "TEXT_ORDER_ID",
    "TEXT_CUSTOMER": "TEXT_CUSTOMER",
    "TEXT_BUYER_NOTE": "TEXT_BUYER_NOTE",
    "TEXT_SELLER_NOTE": "TEXT_SELLER_NOTE",
    "TEXT_EST_DELIVERY": "TEXT_EST_DELIVERY",
    "TEXT_SHIPPING_ADDRESS": "TEXT_SHIPPING_ADDRESS",
    "TEXT_EMAIL": "TEXT_EMAIL",
    "TEXT_EDIT_LISTING_ORDER_NOTE": "TEXT_EDIT_LISTING_ORDER_NOTE",
    "TEXT_LISTING_DETAILS": "TEXT_LISTING_DETAILS",
    "TEXT_ORDER_NOTES": "TEXT_ORDER_NOTES",
    "TEXT_CONFIGURE_VIEW_COLUMNS": "TEXT_CONFIGURE_VIEW_COLUMNS",
    "TEXT_THIS_WEEK": "TEXT_THIS_WEEK",
    "TEXT_LAST_WEEK": "TEXT_LAST_WEEK",
    "TEXT_THIS_MONTH": "TEXT_THIS_MONTH",
    "TEXT_LAST_MONTH": "TEXT_LAST_MONTH",
    "TEXT_TOTAL_ORDERS": "TEXT_TOTAL_ORDERS",
    "TEXT_SHOWING": "TEXT_SHOWING",
    "TEXT_NO_ORDERS_FOUND": "TEXT_NO_ORDERS_FOUND",
    "TEXT_ITEMS_PER_PAGE": "TEXT_ITEMS_PER_PAGE",
    "TEXT_PAGE": "TEXT_PAGE",
    "TEXT_BULK_UPDATE_STATUS": "TEXT_BULK_UPDATE_STATUS",
    "TEXT_ORDERS_SELECTED": "TEXT_ORDERS_SELECTED",
    "TEXT_CANCELLED": "TEXT_CANCELLED",
    "TEXT_WAITING_FOR_PAYMENT": "TEXT_WAITING_FOR_PAYMENT",
    "TEXT_WAIT_FOR_PROCESSING": "TEXT_WAIT_FOR_PROCESSING",
    "TEXT_PROCESSING": "TEXT_PROCESSING",
    "TEXT_PROCESSING_CUSTOM_ORDER": "TEXT_PROCESSING_CUSTOM_ORDER",
    "TEXT_FULFILL_PROCESSING": "TEXT_FULFILL_PROCESSING",
    "TEXT_PACKAGING": "TEXT_PACKAGING",
    "TEXT_DONE_PACKAGING": "TEXT_DONE_PACKAGING",
    "TEXT_SHIPPED_TO_SHIPPING_CENTER": "TEXT_SHIPPED_TO_SHIPPING_CENTER",
    "TEXT_SHIPPED_TO_CUSTOMER": "TEXT_SHIPPED_TO_CUSTOMER",
    "TEXT_CUSTOMS_HOLD": "TEXT_CUSTOMS_HOLD",
    "TEXT_RETURNED_TO_SHIPPING_WAREHOUSE": "TEXT_RETURNED_TO_SHIPPING_WAREHOUSE",
    "TEXT_RETURNED_TO_SHIPPING_CENTER": "TEXT_RETURNED_TO_SHIPPING_CENTER",
    "TEXT_RETURNED_TO_WAREHOUSE": "TEXT_RETURNED_TO_WAREHOUSE",
    "TEXT_COMPLETED": "TEXT_COMPLETED",
    "TEXT_REFUNDED": "TEXT_REFUNDED",
    "TEXT_APPLY": "TEXT_APPLY",
    "TEXT_PRIORITY": "TEXT_PRIORITY",
    "TEXT_PRIORITY_LOW": "TEXT_PRIORITY_LOW",
    "TEXT_PRIORITY_MEDIUM": "TEXT_PRIORITY_MEDIUM",
    "TEXT_PRIORITY_HIGH": "TEXT_PRIORITY_HIGH",
    "TEXT_PRIORITY_EXPRESS": "TEXT_PRIORITY_EXPRESS",
    "TEXT_RND_TITLE": "TEXT_RND_TITLE",
    "TEXT_RND_PRODUCT": "TEXT_RND_PRODUCT",
    "TEXT_RND_ORDER_LIST": "TEXT_RND_ORDER_LIST",
    "TEXT_EIT": "TEXT_EIT",
    "TEXT_SALE_TITLE": "TEXT_SALE_TITLE",
    "TEXT_SALE_ORDER_LIST": "TEXT_SALE_ORDER_LIST",
    "TEXT_SALE_STATS": "TEXT_SALE_STATS",
    "TEXT_FULFILL_TITLE": "TEXT_FULFILL_TITLE",
    "TEXT_FULFILL_ORDER_LIST": "TEXT_FULFILL_ORDER_LIST",
    "TEXT_HISTORY": "TEXT_HISTORY",
    "TEXT_HISTORY_WAREHOUSE": "TEXT_HISTORY_WAREHOUSE",
    "TEXT_HISTORY_DELIVERY": "TEXT_HISTORY_DELIVERY",
    "TEXT_ADMIN_TITLE": "TEXT_ADMIN_TITLE",
    "TEXT_BOD_TITLE": "TEXT_BOD_TITLE",
    "TEXT_PERMISSION_MANAGEMENT": "TEXT_PERMISSION_MANAGEMENT",
    "TEXT_PERMISSIONS": "TEXT_PERMISSIONS",
    "TEXT_USER_GROUPS": "TEXT_USER_GROUPS",
    "TEXT_USERS": "TEXT_USERS",
    "TEXT_K3DOC_VIEW": "TEXT_K3DOC_VIEW",
    "TEXT_K3DOC_LIST": "TEXT_K3DOC_LIST",
    "TEXT_VERSION_NOTIFICATION": "TEXT_VERSION_NOTIFICATION",
    "TEXT_ROOT_TITLE": "TEXT_ROOT_TITLE",
    "TEXT_EDIT_TRANSACTION": "TEXT_EDIT_TRANSACTION",
    "TEXT_CREATE_TRANSACTION": "TEXT_CREATE_TRANSACTION",
    "TEXT_TOTAL_PRODUCTS": "TEXT_TOTAL_PRODUCTS",
    "TEXT_MONTHLY_ID": "TEXT_MONTHLY_ID",
    "TEXT_IMPORT_EXPORT_TITLE": "TEXT_IMPORT_EXPORT_TITLE",
    "TEXT_SELECT_PARTNER": "TEXT_SELECT_PARTNER",
    "TEXT_PRODUCT_CODE": "TEXT_PRODUCT_CODE",
    "TEXT_QUANTITY": "TEXT_QUANTITY",
    "TEXT_ACTION": "TEXT_ACTION",
    "TEXT_ADD_ITEM": "TEXT_ADD_ITEM",
    "TEXT_ENTER_NOTE": "TEXT_ENTER_NOTE",
    "TEXT_SAVING": "TEXT_SAVING",
    "TEXT_PLEASE_SELECT_WAREHOUSE": "TEXT_PLEASE_SELECT_WAREHOUSE",
    "TEXT_PLEASE_FILL_ALL": "TEXT_PLEASE_FILL_ALL",
    "TEXT_SUCCESSFULLY_SAVED": "TEXT_SUCCESSFULLY_SAVED",
    "TEXT_FAILED_SAVE": "TEXT_FAILED_SAVE",
    "TEXT_ADD_LISTING": "TEXT_ADD_LISTING",
    "TEXT_ADD_ORDER": "TEXT_ADD_ORDER",
    "TEXT_ADD_NEW_ORDER": "TEXT_ADD_NEW_ORDER",
    "TEXT_ADDED_REASON": "TEXT_ADDED_REASON",
    "TEXT_ETSY_NEW_ORDER": "TEXT_ETSY_NEW_ORDER",
    "TEXT_ETSY_WARRANTY_ORDER": "TEXT_ETSY_WARRANTY_ORDER",
    "TEXT_NON_ETSY_ORDER": "TEXT_NON_ETSY_ORDER",
    "TEXT_TOTAL_QUANTITY": "TEXT_TOTAL_QUANTITY",
    "TEXT_TOTAL_ITEMS": "TEXT_TOTAL_ITEMS",
    "TEXT_TRANSACTION_DETAILS": "TEXT_TRANSACTION_DETAILS",
    "TEXT_TRANSACTION_ID": "TEXT_TRANSACTION_ID",
    "TEXT_PARTNER": "TEXT_PARTNER",
    "TEXT_SYSTEM_NOTE": "TEXT_SYSTEM_NOTE",
    "TEXT_STAFF_NOTE": "TEXT_STAFF_NOTE",
    "TEXT_INVENTORY_TRANSACTIONS": "TEXT_INVENTORY_TRANSACTIONS",
    "TEXT_SEARCH_TRANSACTIONS": "TEXT_SEARCH_TRANSACTIONS",
    "TEXT_IMPORT_PRODUCTS": "TEXT_IMPORT_PRODUCTS",
    "TEXT_EXPORT_PRODUCTS": "TEXT_EXPORT_PRODUCTS",
    "TEXT_CREATED_AT": "TEXT_CREATED_AT",
    "TEXT_ACTIONS": "TEXT_ACTIONS",
    "TEXT_VIEW": "TEXT_VIEW",
    "TEXT_PREVIOUS_PAGE": "TEXT_PREVIOUS_PAGE",
    "TEXT_NEXT_PAGE": "TEXT_NEXT_PAGE",
    "TEXT_PAGE": "TEXT_PAGE",
    "TEXT_LOADING_TRANSACTIONS": "TEXT_LOADING_TRANSACTIONS",
    "TEXT_PRINT": "TEXT_PRINT",
    "TEXT_VIEW_WAREHOUSE": "TEXT_VIEW_WAREHOUSE",
    "TEXT_SHIPPABLE_ORDERS": "TEXT_SHIPPABLE_ORDERS",
    "TEXT_WAREHOUSE_LAMPS": "TEXT_WAREHOUSE_LAMPS",
    "TEXT_OUT_OF_STOCK_LAMPS": "TEXT_OUT_OF_STOCK_LAMPS",
    "TEXT_TOTAL_ORDERS": "TEXT_TOTAL_ORDERS",
    "TEXT_TOTAL_LAMPS": "TEXT_TOTAL_LAMPS",
    "TEXT_ORDER_DATE": "TEXT_ORDER_DATE",
    "TEXT_MONTHLY_ID": "TEXT_MONTHLY_ID",
    "TEXT_ORDER_ID": "TEXT_ORDER_ID",
    "TEXT_SHOP": "TEXT_SHOP",
    "TEXT_CUSTOMER": "TEXT_CUSTOMER",
    "TEXT_SKU": "TEXT_SKU",
    "TEXT_IMAGE": "TEXT_IMAGE",
    "TEXT_NAME": "TEXT_NAME",
    "TEXT_SIZE": "TEXT_SIZE",
    "TEXT_BUYER_NOTE": "TEXT_BUYER_NOTE",
    "TEXT_USER_NOTE": "TEXT_USER_NOTE",
    "TEXT_ADDRESS": "TEXT_ADDRESS",
    "TEXT_CELL_CODE": "TEXT_CELL_CODE",
    "TEXT_QUANTITY": "TEXT_QUANTITY",
    "TEXT_IOSS": "TEXT_IOSS",
    "TEXT_AVAILABLE": "TEXT_AVAILABLE",
    "TEXT_INVENTORY_CHECK": "TEXT_INVENTORY_CHECK",
    "TEXT_AVAILABLE_PENDING": "TEXT_AVAILABLE_PENDING",
    "TEXT_AVAILABLE_IN_STOCK": "TEXT_AVAILABLE_IN_STOCK",
    "TEXT_AVAILABLE_OUT_OF_STOCK": "TEXT_AVAILABLE_OUT_OF_STOCK",
    "TEXT_AVAILABLE_RESERVED": "TEXT_AVAILABLE_RESERVED",
    "TEXT_AVAILABLE_UNKNOWN": "TEXT_AVAILABLE_UNKNOWN",
    "TEXT_SHIPPING_CENTER_DATE": "TEXT_SHIPPING_CENTER_DATE",
    "TEXT_FULFILL_PROCESSING": "TEXT_FULFILL_PROCESSING",
    "TEXT_PACKAGING": "TEXT_PACKAGING",
    "TEXT_CURRENT_CELL_CODE": "TEXT_CURRENT_CELL_CODE",
    "TEXT_QUANTITY_CHANGE_HISTORY_FOR": "TEXT_QUANTITY_CHANGE_HISTORY_FOR",
    "TEXT_NO_QUANTITY_CHANGES": "TEXT_NO_QUANTITY_CHANGES",
    "TEXT_QUANTITY_CHANGE_ADDED": "TEXT_QUANTITY_CHANGE_ADDED",
    "TEXT_QUANTITY_CHANGE_UPDATED": "TEXT_QUANTITY_CHANGE_UPDATED",
    "TEXT_QUANTITY_CHANGE_DELETED": "TEXT_QUANTITY_CHANGE_DELETED",
    "TEXT_QUANTITY_CHANGE_FAILED": "TEXT_QUANTITY_CHANGE_FAILED",
    "TEXT_QUANTITY_CHANGE_CONFIRM_DELETE": "TEXT_QUANTITY_CHANGE_CONFIRM_DELETE",
    "TEXT_QUANTITY_CHANGE_CONFIRM_UPDATE": "TEXT_QUANTITY_CHANGE_CONFIRM_UPDATE",
    "TEXT_QUANTITY_CHANGE_CONFIRM_ADD": "TEXT_QUANTITY_CHANGE_CONFIRM_ADD",
    "TEXT_QUANTITY_CHANGE_TYPE_IN": "TEXT_QUANTITY_CHANGE_TYPE_IN",
    "TEXT_QUANTITY_CHANGE_TYPE_OUT": "TEXT_QUANTITY_CHANGE_TYPE_OUT",
    "TEXT_QUANTITY_CHANGE_TYPE_ADJUST": "TEXT_QUANTITY_CHANGE_TYPE_ADJUST",
    "TEXT_QUANTITY_CHANGE_TYPE_RETURN": "TEXT_QUANTITY_CHANGE_TYPE_RETURN",
    "TEXT_QUANTITY_CHANGE_TYPE_DAMAGE": "TEXT_QUANTITY_CHANGE_TYPE_DAMAGE",
    "TEXT_QUANTITY_CHANGE_TYPE_OTHER": "TEXT_QUANTITY_CHANGE_TYPE_OTHER",
    "TEXT_QUANTITY_CHANGE_TYPE_IMPORT": "TEXT_QUANTITY_CHANGE_TYPE_IMPORT",
    "TEXT_QUANTITY_CHANGE_TYPE_EXPORT": "TEXT_QUANTITY_CHANGE_TYPE_EXPORT",
    "TEXT_QUANTITY_CHANGE_TYPE_INVENTORY_CHECK": "TEXT_QUANTITY_CHANGE_TYPE_INVENTORY_CHECK",
    "TEXT_DISPLAY_CONFIG": "TEXT_DISPLAY_CONFIG",
    "TEXT_REVENUE_30_DAYS": "TEXT_REVENUE_30_DAYS",
    "TEXT_SALE_RATIO": "TEXT_SALE_RATIO",
};

const LANGUAGE_CODES = {
  EN: 0,
  VN: 1
};

export const getCurrentLanguage = () => {
  let currentLanguage = window.localStorage.getItem("eit_language");
  if (!currentLanguage || ["EN", "VN"].indexOf(currentLanguage) === 1) currentLanguage = "VN";

  return currentLanguage.toLowerCase();
};
export const getCurrentLanguageForMoment = () => {
  let currentLanguage = window.localStorage.getItem("eit_language");
  if (!currentLanguage || ["EN", "VN"].indexOf(currentLanguage) === -1) currentLanguage = "VN";
  return currentLanguage.toLowerCase();
};

export const getTranslate = (key, components) => {
  if (!LANGUAGE_KEYS[key]) return key;

  let currentLanguage = window.localStorage.getItem("eit_language");
  if (!currentLanguage || ["EN", "VN"].indexOf(currentLanguage) === -1) currentLanguage = "VN";

  const langCode = LANGUAGE_CODES[currentLanguage];
  let text = LANGUAGES[key][langCode];

  if (!components) return text;

  const keys = text.split("[@]");
  // console.log("language @", keys);
  const output = (
    <>
      {keys.map((k, i) => (
        <>
          {k}
          {components[i]}
        </>
      ))}
    </>
  );

  return output;
};

export const getCustomTranslate = (prefix, text, components) => {
  if (!text) return "";

  const modifyText = text.replace("-", "_").replace("(", "").replace(")", "");
  const keyOnly = prefix
    ? [
        prefix,
        modifyText
          .split(" ")
          .filter((v) => v)
          .join("_")
          .toUpperCase(),
      ].join("_")
    : modifyText
        .split(" ")
        .filter((v) => v)
        .join("_")
        .toUpperCase();

  const key = ["TEXT", keyOnly].join("_");

  let tmp = window.localStorage.getItem(`LANG_${prefix}`);

  if (!tmp) tmp = "";

  const line = `${keyOnly}\t${text}\n`;

  if (!tmp.includes(line)) tmp += line;

  window.localStorage.setItem(`LANG_${prefix}`, tmp);

  return getTranslate(key, components);
};
